<mat-icon [matMenuTriggerFor]="menu">more_vert</mat-icon>
<mat-menu #menu="matMenu" xPosition="before" class="menu">
    <ng-content select="liebherr-action-menu-item"></ng-content>
</mat-menu>
